import React from 'react'

import { DeviceType, useDeviceType } from '@library/dom'

import type { Recipe } from '@library/menu-service'
import { LandingPageContentSections } from '../../../tracking'
import { Carousel } from '../Carousel'
import { Slide } from '../Slide/Slide'

type RecipeCarouselProps = {
  recipes: Recipe[]
}

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.ENDLESS_VARIETY,
}

export const RecipeCarousel = ({ recipes }: RecipeCarouselProps) => {
  const deviceType = useDeviceType()
  const isMobileDevice = deviceType === DeviceType.MOBILE

  return (
    <Carousel
      carouselAreaLabel="Endless Variety"
      options={{ loop: true }}
      slidePaddingH={1}
      slidePaddingV={1}
      slideWidth="320px"
      showNavButtons={!isMobileDevice}
      snowplowTrackingProperties={propertiesForTracking}
    >
      {recipes.reduce((acc: JSX.Element[], recipe, index) => {
        if (recipe.images.length) {
          acc.push(<Slide key={`${recipe.name}-${index}`} recipe={recipe} />)
        }
        return acc
      }, [])}
    </Carousel>
  )
}
